



















import {Component} from 'vue-property-decorator';
import Slide from '@/presentation/slides/Slide';
import moment from 'moment';

@Component({components: {}})
export default class Schedule extends Slide {
  grow(i: number) {
    if (i === this.items.length - 1) {
      return 0;
    }
    const t1 = moment(this.items[i].Date);
    const t2 = moment(this.items[i + 1].Date);
    return t2.diff(t1, 'days');
  }

  date(date: any) {
    if (moment(date).format('YYYYMMDD') === moment(new Date()).format('YYYYMMDD')) {
      return 'idag';
    }
    return moment(date).format('YYYY-MM-DD');
  }

  timeClass(date: any) {
    if (moment(date).format('YYYYMMDD') < moment(new Date()).format('YYYYMMDD')) {
      return 'passed';
    }
    if (moment(date).format('YYYYMMDD') === moment(new Date()).format('YYYYMMDD')) {
      return 'today';
    }
    return '';
  }

  get items() {
    if (!this.section || !this.section.Items) {
      return [];
    }
    return this.section.Items.filter((x: any) => x.Text && x.Date).sort(
        (a: any, b: any) => Number(moment(a.Date).format('YYYYMMDD')) - Number(moment(b.Date).format('YYYYMMDD')));
  }
}
